export default {"src":"/_next/static/media/happy-face-icon.611f8d5d.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};